import type { CityConfig } from "../city-template/types";

export const montroseConfig: CityConfig = {
  city: "Montrose",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "montrose",
  route: "/montrose",
  title: "Emergency Passport Montrose, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Montrose, Colorado — as fast as 24 hours. Same-day courier processing for Montrose, Delta, Olathe, Ridgway, Ouray, Telluride, and all Western Slope travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Montrose, CO",
  heroSubtitle: "Fly fishing trip to Patagonia and your passport just expired? International adventure travel booked months ago? We help Montrose residents — from Black Canyon explorers to San Juan Mountain adventurers to Western Slope families — get their passports quickly. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Montrose%20Colorado%20scenic%20landscape%20with%20the%20Black%20Canyon%20of%20the%20Gunnison%20National%20Park%20dramatic%20gorge%20walls%20in%20the%20distance%2C%20the%20Uncompahgre%20Plateau%20rising%20on%20the%20western%20horizon%2C%20the%20fertile%20Uncompahgre%20River%20valley%20with%20agricultural%20fields%20and%20ranch%20lands%2C%20the%20San%20Juan%20Mountains%20with%20snow%20capped%20peaks%20visible%20to%20the%20south%2C%20golden%20hour%20light%20casting%20dramatic%20shadows%20across%20the%20high%20desert%20terrain%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20view%20with%20dramatic%20western%20Colorado%20light&width=1800&height=700&seq=montrose-hero-001&orientation=landscape",
  heroImageAlt: "Montrose Colorado with Black Canyon of the Gunnison and San Juan Mountain views",
  geoPosition: "38.4783;-107.8762",
  geoPlacename: "Montrose, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 270 miles east via US-50 and I-70 — about 4.5–5 hours",
  },
  nearbyCitiesZips: [
    { name: "Montrose", zips: "81401, 81402, 81403" },
    { name: "Delta", zips: "81416" },
    { name: "Olathe", zips: "81425" },
    { name: "Ridgway", zips: "81432" },
    { name: "Ouray", zips: "81427" },
    { name: "Telluride", zips: "81435" },
    { name: "Naturita", zips: "81422" },
    { name: "Nucla", zips: "81424" },
    { name: "Norwood", zips: "81423" },
    { name: "Gunnison", zips: "81230, 81231" },
    { name: "Grand Junction", zips: "81501, 81503, 81504" },
    { name: "Cedaredge", zips: "81413" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Montrose international departures via MTJ or GJT" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the 5-hour drive to Denver" },
    { icon: "ri-flight-takeoff-line", title: "MTJ Regional Airport", desc: "Montrose Regional Airport serves the entire Western Slope and San Juan Mountains" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from UPS or FedEx in Montrose, Delta, or Grand Junction" },
  ],
  internalLinks: [
    { name: "Expedited passport in Grand Junction, CO", route: "/grand-junction" },
    { name: "Emergency passport help in Telluride, CO", route: "/telluride" },
    { name: "Fast passport renewal in Montrose area", route: "/montrose" },
    { name: "Urgent passport services for Delta and Olathe", route: "/montrose" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services in Ouray and Ridgway", route: "/montrose" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Montrose remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Montrose's location on the Western Slope — 270 miles from the Colorado Passport Agency (a 5-hour drive over mountain passes) — makes our courier service absolutely essential. Skip the all-day drive and let us handle everything from Montrose.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Montrose, Montrose County, and the entire Western Slope region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Montrose and the surrounding Western Slope region. From downtown Montrose along Main Street to the communities near the Uncompahgre River, from the Montrose Regional Airport area to the neighborhoods along the San Juan Skyway — we serve every corner of Montrose and the surrounding communities.",
  nearbyCitiesIntro: "We serve Montrose and all nearby communities including Delta, Olathe, Ridgway, Ouray, Telluride, Naturita, Nucla, Norwood, Gunnison, Grand Junction, and the entire Western Slope region.",
  howItWorksIntro: "Most Montrose travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — you never need to drive 270 miles (5 hours) to Denver over mountain passes. For Western Slope travelers, our courier service isn't just convenient — it's the only practical option for fast passport processing.",
  mistakesIntro: "Montrose is the Western Slope's regional hub — home to Black Canyon National Park, the San Juan Mountains, and the Montrose Regional Airport. Here are the most common passport mistakes we see from Montrose-area travelers.",
  testimonialsIntro: "Montrose travelers — from Black Canyon adventurers to San Juan Mountain explorers to Western Slope families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Montrose, CO? Here are the most common ones we hear from Western Slope travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver — 5 hours each way", "Mountain pass travel — weather-dependent year-round"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive required — ship from Montrose", "Essential for Western Slope travelers 270 miles from Denver", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Montrose travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the only practical fast passport option for Western Slope residents 270 miles from Denver.",
      bullets: ["24–48 hour turnaround available", "MTJ (Montrose) and GJT (Grand Junction) departure support", "Adventure travel and family vacation expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Montrose adults with a passport issued within the last 15 years. Skip the post office — we handle everything remotely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Montrose address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Montrose residents and Western Slope families — including rural and ranch community residents.",
      bullets: ["Acceptance facility scheduling in Montrose or Delta", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Montrose residents — critical when you're 5 hours from the nearest passport agency.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Montrose and Western Slope families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Montrose and Montrose County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Montrose CO", description: "Urgent passport processing for Montrose Colorado travelers with immediate departure needs from MTJ." },
    { name: "Expedited Passport Renewal Montrose CO", description: "Fast passport renewal for Montrose Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Montrose CO", description: "New passport application services for Montrose Colorado residents applying for their first passport." },
    { name: "Child Passport Montrose CO", description: "Minor passport services for Montrose Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Tom B.",
      location: "Montrose, CO — Downtown",
      rating: 5,
      text: "Fly fishing trip to Patagonia booked for 2 years and realized my passport expired 2 weeks before. Fast Passport Center got it done in 4 days. Being 5 hours from Denver on the Western Slope, their courier service is literally the only way to get a passport fast out here.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Nancy R.",
      location: "Montrose, CO — Spring Creek",
      rating: 5,
      text: "Family trip to Italy and my husband's passport had water damage. Fast Passport Center replaced it in 5 days. Shipped from the UPS Store in Montrose — so easy. No way we were driving 10 hours round trip to Denver.",
      service: "Emergency Passport Replacement",
    },
    {
      name: "Mike S.",
      location: "Delta, CO",
      rating: 5,
      text: "First passport ever at 55 for a trip to Scotland. Fast Passport Center walked me through the entire process — from DS-11 to photos to shipping. Had my passport in 6 days. Absolutely fantastic service for Western Slope residents.",
      service: "First-Time Passport",
    },
    {
      name: "Carol W.",
      location: "Olathe, CO",
      rating: 5,
      text: "Needed three passports for our family heading to a wedding in Mexico. Fast Passport Center handled everything — got all three in 5 days. For rural Western Slope families, this courier service is a game-changer.",
      service: "Family Passport Bundle",
    },
  ],
  facilities: [
    {
      id: "mtr-1",
      name: "Montrose Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "321 S 1st St",
      city: "Montrose",
      state: "CO",
      zip: "81401",
      phone: "(970) 249-3383",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Montrose, near Main Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Montrose acceptance facility. Limited hours — closes at 4PM. Appointments recommended. Serves Montrose and surrounding Montrose County.",
      icon: "ri-mail-line",
    },
    {
      id: "mtr-2",
      name: "Delta Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "360 Meeker St",
      city: "Delta",
      state: "CO",
      zip: "81416",
      phone: "(970) 874-5554",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 20 miles north of Montrose, in Delta",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern Montrose County acceptance facility. Serves Delta, Olathe, and the North Fork Valley. Limited hours — call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "mtr-3",
      name: "Grand Junction Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "241 N 4th St",
      city: "Grand Junction",
      state: "CO",
      zip: "81501",
      phone: "(970) 245-3369",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Approximately 60 miles north of Montrose, in Grand Junction",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest regional acceptance facility. Extended hours and more appointment availability. Good option if Montrose appointments are full — about a 1-hour drive north.",
      icon: "ri-mail-line",
    },
    {
      id: "mtr-4",
      name: "Montrose County Clerk & Recorder",
      type: "County Clerk Passport Acceptance",
      address: "317 S 2nd St",
      city: "Montrose",
      state: "CO",
      zip: "81401",
      phone: "(970) 249-3362",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Downtown Montrose, near the Montrose County Courthouse",
      website: "https://www.montrosecounty.net/",
      websiteLabel: "Montrose County Clerk",
      notes: "County government passport acceptance. Convenient downtown location. Serves all Montrose County residents. 8:30AM opening — better than post office for early appointments.",
      icon: "ri-government-line",
    },
    {
      id: "mtr-5",
      name: "Gunnison Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 N Wisconsin St",
      city: "Gunnison",
      state: "CO",
      zip: "81230",
      phone: "(970) 641-1150",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 65 miles east of Montrose, in Gunnison",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Eastern acceptance facility for Montrose-Gunnison corridor. Serves Gunnison, Crested Butte, and the upper Gunnison Valley. Mountain pass travel required.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5-hour drive to Denver over mountain passes", fpc: "No — ship from Montrose" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Mountain Pass Travel", agency: "Weather-dependent — dangerous in winter", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Underestimating Distance from Denver",
      description: "Montrose is 270 miles and a 5-hour drive from Denver over Monarch Pass or I-70. Many Western Slope residents don't realize how far the nearest passport agency is until they need it. Start expedited service early — you can't just 'drive to Denver' for a same-day passport.",
    },
    {
      icon: "ri-image-line",
      title: "Using Non-Compliant Rural Photo Services",
      description: "Rural area photo services in Montrose may not stay current on State Department requirements. Passport photos must be exactly 2×2 inches on a white background — no exceptions. Verify your photo provider knows current passport standards.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptances Early Enough",
      description: "Montrose Post Office has limited hours (closes at 4PM) and limited appointments. During peak summer travel season, appointments fill quickly. Book 2–3 weeks ahead or plan to drive to Grand Junction for more availability.",
    },
    {
      icon: "ri-snowflake-line",
      title: "Underestimating Mountain Pass Travel",
      description: "Driving from Montrose to Denver means crossing Monarch Pass (11,312 ft) or taking I-70 through Glenwood Canyon — both are weather-dependent year-round. Winter closures can make the trip impossible. Our courier service eliminates mountain pass travel entirely.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Passport Validity Before Booking International Flights from MTJ",
      description: "Montrose Regional Airport (MTJ) offers seasonal flights to hubs like DEN, DFW, and PHX — but connections to international destinations require valid passports. Verify your passport before booking international itineraries through MTJ.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Assuming MTJ Has International Flights",
      description: "Montrose Regional Airport is a domestic-only airport. All international travel requires a connection through a major hub. Make sure you have sufficient layover time at the connecting airport for international check-in procedures.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Montrose or the Western Slope." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at UPS or FedEx in Montrose, Delta, or Grand Junction." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Montrose County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no 5-hour mountain pass drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Montrose address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Montrose, CO?", a: "Fast Passport Center offers emergency passport processing in Montrose, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to drive 270 miles (5 hours) over mountain passes to the Colorado Passport Agency. For Western Slope residents, our courier service isn't just convenient — it's essential." },
    { q: "How far is Montrose from the nearest passport agency?", a: "Montrose is approximately 270 miles from the Colorado Passport Agency in Aurora — a 5-hour drive one way. The route requires crossing Monarch Pass (11,312 ft) on US-50 or taking I-70 through Glenwood Canyon. Mountain pass travel is weather-dependent year-round, making our courier service the only practical option for fast passport processing." },
    { q: "Does Montrose have its own passport acceptance facility?", a: "Yes — Montrose has two options: the Montrose Post Office (321 S 1st St) and the Montrose County Clerk (317 S 2nd St). The County Clerk offers better hours (8:30AM opening) and is often less crowded. For more appointment availability, Grand Junction (60 miles north) has a larger facility." },
    { q: "What if I live in Delta, Olathe, Ridgway, or Ouray?", a: "Absolutely. Fast Passport Center serves all of Montrose County and the surrounding region including Delta, Olathe, Ridgway, Ouray, Telluride, Naturita, Nucla, Norwood, and Gunnison. Our service works the same way everywhere — ship your documents from any nearby UPS or FedEx location." },
    { q: "Can you help with passports for international adventure travelers?", a: "Yes. Fast Passport Center serves Montrose's outdoor adventure community — from fly fishing enthusiasts heading to Patagonia to hikers trekking the Alps to mountain bikers traveling internationally. We understand the needs of adventure travelers who often book trips far in advance and discover passport issues last-minute." },
    { q: "How much does an expedited passport cost in Montrose, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote — our service is especially valuable for Western Slope residents who would otherwise need to drive 10+ hours round trip to Denver." },
    { q: "Where can I get passport photos in Montrose?", a: "Walgreens (16400 S Townsend Ave), City Market (16400 S Townsend Ave), and the UPS Store (2460 S Townsend Ave) all offer passport photo services in Montrose. FedEx Office in Grand Junction is another option. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the entire Western Slope?", a: "Yes. Fast Passport Center serves the full Western Slope region including Montrose, Delta, Olathe, Ridgway, Ouray, Telluride, Grand Junction, Gunnison, and all surrounding communities. Our courier service is designed for rural and remote Colorado residents who live hours from the nearest passport agency." },
  ],
  photoLocations: [
    { name: "Walgreens — Montrose", address: "16400 S Townsend Ave, Montrose, CO 81401", hours: "Mon–Sun: 8AM–9PM" },
    { name: "City Market — Montrose", address: "16400 S Townsend Ave, Montrose, CO 81401", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Montrose", address: "2460 S Townsend Ave, Montrose, CO 81401", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM" },
    { name: "FedEx Office — Grand Junction", address: "2490 Highway 6 and 50, Grand Junction, CO 81505", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM" },
  ],
  dmvLocations: [
    { name: "DMV — Montrose (Montrose County)", address: "2300 S Townsend Ave, Montrose, CO 81401", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV in Montrose. REAL ID and driver's license renewals. Serves Montrose County and the surrounding Western Slope communities.", featured: true },
    { name: "DMV — Delta (Delta County)", address: "501 Palmer St, Delta, CO 81416", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV in Delta for northern Montrose County residents. REAL ID processing available. Approximately 20 miles from Montrose.", featured: false },
  ],
  airports: [
    {
      code: "MTJ",
      name: "Montrose Regional Airport",
      distance: "3 miles northwest of downtown Montrose — approximately 5 minutes",
      address: "2100 Airport Rd, Montrose, CO 81401",
      note: "Western Slope's primary regional airport with seasonal flights to major hubs including DEN, DFW, PHX, ORD, and LAX. No international flights — all international travel requires a connection. Essential gateway for Telluride, Ouray, and Black Canyon visitors.",
      flightUrl: "https://www.montroseairport.com/",
      flightLabel: "MTJ Flight Info",
      featured: true,
    },
    {
      code: "GJT",
      name: "Grand Junction Regional Airport",
      distance: "60 miles north via US-50 — approximately 1 hour",
      address: "2828 Walker Field Dr, Grand Junction, CO 81506",
      note: "Largest Western Slope airport with year-round flights to DEN, PHX, SLC, DFW, and LAS. More consistent service than MTJ. No international flights — all international travel requires a connection through a major hub.",
      flightUrl: "https://www.gjairport.com/",
      flightLabel: "GJT Flight Info",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth & Death Certificates", desc: "Order certified Colorado birth and death certificates from the Colorado Department of Public Health and Environment Vital Records — online, by mail, or in person at the Montrose County Clerk.", url: "https://cdphe.colorado.gov/vital-records" },
    { icon: "ri-hearts-line", label: "Marriage Records", desc: "Request certified marriage certificates from the Montrose County Clerk at 317 S 2nd St. Required for name change passport applications.", url: "https://www.montrosecounty.net/" },
    { icon: "ri-file-copy-line", label: "Divorce Decrees", desc: "Obtain certified divorce records through the Montrose County District Court. Required for name change passport corrections.", url: "https://www.courts.state.co.us/" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Colorado, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};